import { useQuery } from '@tanstack/react-query';
import axiosInstance from '../utils/axios';

export const networkGetArtistTypeList = async () => {
  const res = await axiosInstance.post('ArtistsType/List');
  return res;
};

export function useFetchArtistTypeList() {
  return useQuery({
    queryKey: ['artist-type-list'],
    queryFn: () => networkGetArtistTypeList(),
  });
}

export const networkGetArtistTypeListV2 = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`ArtistsTypeJoinContent/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchArtistTypeListV2(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['artist-type-list-V2', payload],
    queryFn: () => networkGetArtistTypeListV2(payload, pageIndex, pageSize),
  });
}

export const networkGetArtistList = async (payload, pageIndex = 0, pageSize = 50) => {
  const res = await axiosInstance.post(`Artists/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchArtistList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: ['artist-list', payload, pageIndex],
    queryFn: () => networkGetArtistList(payload, pageIndex, pageSize),
  });
}

export const networkCreateArtist = async (data) => {
  const res = await axiosInstance.post('Artists/Insert', data);
  return res;
};

export const networkUpdateArtist = async (artistId, data) => {
  const res = await axiosInstance.post(`Artists/Update/${artistId}`, data);
  return res;
};

export const networkRemoveArtist = async (artistId) => {
  const res = await axiosInstance.post(`Artists/Remove/${artistId}`);
  return res;
};
